const AOS = require("./../../external/aos.js");

const ROW_SELECTOR = ".bn-row.is-style-show-more";
const BUTTON_SELECTOR = ".is-style-show-more";
const HIDDEN_CLASS = "bn-row__item--hidden";
const EXPANDED_CLASS = "--show-more-expanded";
const VISIBLE_ROWS = 3;
const DEFAULT_LABEL_LESS = "Hide Client Profiles";

function getRowItems(row) {
    return Array.from(row.children).filter((child) => child.classList.contains("bn-column"));
}

// Groups items by their offsetTop so the visual row layout (which shifts per breakpoint) decides the split, not a fixed item count.
function groupByRow(items) {
    const rows = [];
    let lastTop = null;

    items.forEach((item) => {
        const top = item.offsetTop;

        if (lastTop === null || Math.abs(top - lastTop) > 1) {
            rows.push([]);
            lastTop = top;
        }

        rows[rows.length - 1].push(item);
    });

    return rows;
}

// A row's control can be any "Show more" styled button/link placed anywhere in its section, not just inside the row.
function findRowButton(row) {
    const scope = row.closest(".bn-section") || row.parentElement;
    if (!scope) {
        return null;
    }

    return Array.from(scope.querySelectorAll(BUTTON_SELECTOR)).find((candidate) => !row.contains(candidate)) || null;
}

function updateRow(row, button) {
    const items = getRowItems(row);
    const isExpanded = row.classList.contains(EXPANDED_CLASS);

    items.forEach((item) => item.classList.remove(HIDDEN_CLASS));

    const rows = groupByRow(items);

    if (rows.length <= VISIBLE_ROWS) {
        button.hidden = true;
        row.classList.remove(EXPANDED_CLASS);
        return;
    }

    if (!isExpanded) {
        rows.slice(VISIBLE_ROWS).forEach((rowItems) => {
            rowItems.forEach((item) => item.classList.add(HIDDEN_CLASS));
        });
    }

    button.hidden = false;
    button.textContent = isExpanded ? button.dataset.labelLess : button.dataset.labelMore;
}

function rowShowMore() {
    const rowsWithButtons = Array.from(document.querySelectorAll(ROW_SELECTOR))
        .map((row) => ({ row, button: findRowButton(row) }))
        .filter(({ button }) => button);

    if (!rowsWithButtons.length) {
        return;
    }

    rowsWithButtons.forEach(({ row, button }) => {
        if (!button.dataset.labelMore) {
            button.dataset.labelMore = button.textContent.trim();
        }
        if (!button.dataset.labelLess) {
            button.dataset.labelLess = row.dataset.labelLess || DEFAULT_LABEL_LESS;
        }

        button.addEventListener("click", (event) => {
            event.preventDefault();
            const wasExpanded = row.classList.contains(EXPANDED_CLASS);
            row.classList.toggle(EXPANDED_CLASS);
            updateRow(row, button);

            if (wasExpanded) {
                row.scrollIntoView({ behavior: "smooth", block: "start" });
            }

            AOS.refresh();
        });

        updateRow(row, button);
    });

    AOS.refresh();

    let resizeTimeout;
    const recalculate = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            rowsWithButtons.forEach(({ row, button }) => updateRow(row, button));
            AOS.refresh();
        }, 150);
    };

    window.addEventListener("resize", recalculate);
    window.addEventListener("load", recalculate);
}

module.exports = { rowShowMore };
